<template>
  <div class="container">
    <!-- 상단 타이틀 -->
    <div class="logoTitle colorBlack">
      <p class="main">G멤버스 <strong>오류안내</strong></p>
    </div>

    <!-- 오류 안내 박스 (EagleBox 활용) -->
    <div class="mb20">
      <eagle-box
        :title="btnTmp.title"
        :sub-title="btnTmp.subTitle"
        :btn-name="btnTmp.btnName"
        :btnType="btnTmp.btnType"
        :is-btn="btnTmp.isBtn"
      />
    </div>

    <!-- 홈으로 이동 버튼 -->
    <div class="mt50">
      <button
        type="button"
        class="btn full black"
        @click="goHome()"
      >
        홈으로 돌아가기
      </button>
    </div>
  </div>
</template>

<script>
import EagleBox from '@/common/EagleBox.vue'

export default {
  name: 'errPage',
  components: { EagleBox },

  data () {
    return {
      /*
       * 오류 안내 박스에 전달할 데이터 세트
       * - title: 에러 제목
       * - subTitle: 보조 안내 문구
       * - isBtn: 버튼 표시 여부 (이 페이지에선 false)
       * - btnName/btnType: 버튼 텍스트/타입 (isBtn이 false라 사용되지 않음)
       */
      btnTmp: {
        title: '일시적인 오류입니다.',
        subTitle: '잠시 후 다시 시도해 주세요.',
        isBtn: false,
        btnName: '',
        btnType: ''
      }
    }
  },

  methods: {
    // 홈으로 이동
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>
